import type { FaireProductEntity } from "../../entity_types/product";

export const p_6h4zvq5ana: FaireProductEntity = {
  token: "p_6h4zvq5ana",
  type: "product",
  name: "1.25 In Martini Olive Cocktail Brooch Pin Set of 3",
  brandName: "Designature New York",
  imageUrl:
    "https://cdn.faire.com/fastly/35064358ea9031f029ed5f22a4f756618f10708d2494ce72bbf90471c242052e.jpeg",
  priceDollars: 6.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/9ec7076b3c292d7d09192fd20b4bb61ed859a1a95718665ea73c5918e5814b44.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
